/**
 * RBAC-3.6 · UX-DR10. The unsaved-changes banner: the count of changes AND, separately, who it
 * affects, including whether that is you. Copy is `lib/roleSaveBanner.ts`.
 *
 * Save opens the Review changes dialog; nothing saves without the diff (FR-13).
 */
import { Button } from '@/components/ui/button';
import { bannerCopy } from '@/lib/roleSaveBanner';
import type { RoleHolders } from '@/lib/rolePermissionDiff';

export interface UnsavedChangesBannerProps {
  changes: number;
  holders: RoleHolders | null;
  holdersState: 'loading' | 'error' | 'ready';
  onDiscard: () => void;
  onSave: () => void;
}

export function UnsavedChangesBanner({ changes, holders, holdersState, onDiscard, onSave }: UnsavedChangesBannerProps) {
  const copy = bannerCopy(changes, holders, holdersState);
  return (
    <div
      role="status"
      className="flex flex-wrap items-center justify-between gap-3 rounded-md border border-emerald-500 bg-emerald-50 px-3 py-2 text-sm dark:border-emerald-500/60 dark:bg-emerald-950/40"
    >
      <div className="min-w-0">
        <p className="font-medium text-foreground">{copy.title}</p>
        <p className="text-muted-foreground">{copy.affects}</p>
      </div>
      <div className="flex shrink-0 gap-2">
        <Button variant="outline" size="sm" onClick={onDiscard}>
          Discard
        </Button>
        <Button size="sm" onClick={onSave}>
          Review and save
        </Button>
      </div>
    </div>
  );
}
